import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './base-query';

const uploadAPI = createApi({
  reducerPath: 'uploadAPI',
  baseQuery,
  endpoints: (builder) => ({
    getUploadUrl: builder.mutation({
      query: (payload) => ({
        url: '/api/v1/admin/files/upload-url',
        method: 'POST',
        body: payload, // { contentType, purpose }
      }),
    }),
  }),
});

export const { useGetUploadUrlMutation } = uploadAPI;
export default uploadAPI;
